import React from 'react'
import PropTypes from 'prop-types'
import ShowcasePlaceholder from './ShowcasePlaceholder'
import ShowcaseHeader from './ShowcaseHeader'
import ShowcaseProductListWrapper from './ShowcaseProductListWrapper'

const Showcase = ({ children, isLoading, products, title, mobileTitle, viewAllPath }) => (
  <ShowcasePlaceholder isLoading={isLoading && products.length === 0}>
    <div className='showcard-products container-card container py-1 py-md-3 px-0 px-md-0 mx-1 mx-md-0'>
      <ShowcaseHeader title={title} mobileTitle={mobileTitle} viewAllPath={viewAllPath} />
      <ShowcaseProductListWrapper>
        {children}
      </ShowcaseProductListWrapper>
    </div>
  </ShowcasePlaceholder>
)

Showcase.propTypes = {
  title: PropTypes.string,
  mobileTitle: PropTypes.string,
  viewAllPath: PropTypes.string,
  isLoading: PropTypes.bool,
  products: PropTypes.array,
  children: PropTypes.any.isRequired
}

export default Showcase



// WEBPACK FOOTER //
// ./src/features/Showcase/Showcase.js